import useNotificationSettingsQueryOptions from '@/features/user/queries/useNotificationSettingsQueryOptions';
import useAuthenticatedQuery from '@/shared/hooks/useAuthenticatedQuery';

export default function useNotificationSettingsQuery() {
  return useAuthenticatedQuery(useNotificationSettingsQueryOptions());
}
